export const locales = {
  en: {
    frensMinting: "Frens Minting",
    paidMinting: "Paid Minting",
    freeMintFirst: "free mint – first 1000 – all claimed!",
    freeMintWhitelist: "free mint for whitelist holders – all claimed!",
    connectWallet: "Connect Wallet",
    connectWalletFirst: "Please connect your wallet first.",
    noNftsLeft: "No NFTs left for minting! Please check raffles/auctions.",
  },
  ru: {
    frensMinting: "Минтинг для друзей",
    paidMinting: "Платный минтинг",
    freeMintFirst: "бесплатный минт – первые 1000 – все разобраны!",
    freeMintWhitelist: "бесплатный минт для держателей whitelist – все разобраны!",
    connectWallet: "Подключить кошелек",
    connectWalletFirst: "Пожалуйста, сначала подключите кошелек.",
    noNftsLeft: "NFT закончились для минтинга! Пожалуйста, проверьте розыгрыши/аукционы.",
  },
};

export type Locale = keyof typeof locales;